/**
 * Hook to check if the maintenance mode is enabled for the current user.
 * @returns An object containing the maintenance mode status and loading state.
 * @returns isMaintenanceMode - Whether the maintenance mode is enabled.
 * @returns isLoading - Whether the maintenance mode check is in progress.
 */
export const useMaintenanceMode = (): {
  isMaintenanceMode: boolean;
  isLoading: boolean;
} => {
  return {
    isMaintenanceMode: false,
    isLoading: false,
  };
};
